const prepModalBtns = () => {
  let SELECTED_SAVED_SEARCH_INDEX = 0;

  const modalContainer = document.getElementById("fp-saved-search-modal");

  modalContainer.addEventListener("click", () => {
    closeModal();
  });

  const savedSearchHeader = document.querySelectorAll(`[class^="fp-saved-search-header"]`);

  const formContainer = document.getElementById(`fp-form-container`);

  formContainer.addEventListener("click", (event) => {
    event.stopPropagation(); // for close on click-outside
  });

  const formHeader = document.getElementById("fp-form-header");
  const formTitle = document.getElementById("fp-form-label");
  const formCancelBtn = document.getElementById("fp-form-cancel");
  const formSaveBtn = document.getElementById("fp-form-save");
  const formDeleteBtn = document.getElementById("fp-form-delete");
  const formInput = document.getElementById("fp-form-input");
  const formClose = document.getElementById("fp-close-saved-search");

  // get shop domain and web app domain from the form
  const form = document.getElementById("fp-rename-search-modal-form");
  const formData = new FormData(form);

  const shopDomain = formData.get("shop-domain");
  const webAppDomain = formData.get("web-app-domain");

  let savedSearchId = "";

  formCancelBtn.addEventListener("click", (event) => {
    event.preventDefault();
    closeModal();
  });

  formSaveBtn.addEventListener("click", async (event) => {
    event.preventDefault();
    savedSearchHeader[SELECTED_SAVED_SEARCH_INDEX].innerHTML = formInput.value;
    await updateSavedSearch(formInput.value);
    closeModal();
  });

  formDeleteBtn.addEventListener("click", async (event) => {
    event.preventDefault();
    await deleteSavedSearch();
    window.location.reload();
    closeModal();
  });

  formClose.addEventListener("click", (event) => {
    event.preventDefault();
    closeModal();
  });

  const manageButtons = document.querySelectorAll(".fp-manage-content-btn");

  manageButtons.forEach((manageBtn) => {
    manageBtn.addEventListener("click", (event) => {
      const { savedSearchIndex, screenSize } = event.target.dataset;
      const dropdownContent = document.querySelector(
        `.fp-dropdown-content[data-saved-search-index="${savedSearchIndex}"][data-screen-size="${screenSize}"]`,
      );
      const renameOption = dropdownContent.getElementsByTagName("button")[0];
      const deleteOption = dropdownContent.getElementsByTagName("button")[1];

      dropdownContent.classList.toggle("show");

      // open modal to rename saved search
      renameOption.addEventListener("click", () => {
        const existingError = document.querySelector("#fp-save-search-error");
        if (existingError) existingError.remove();
        formInput.style.border = "";
        formError.textContent = "";

        const savedSearchHeaderLatestVal =
          savedSearchHeader[savedSearchIndex]?.textContent || renameOption.dataset.savedSearchName;
        formInput.value = savedSearchHeaderLatestVal;
        savedSearchId = renameOption.dataset.searchId;

        formTitle.innerHTML = "Name of the Search";
        formSaveBtn.style.display = "block";
        formDeleteBtn.style.display = "none";
        formHeader.innerHTML = "Rename Saved Search";
        formInput.style.display = "block";
        modalContainer.style.display = "block";
        dropdownContent.classList.toggle("show");
        SELECTED_SAVED_SEARCH_INDEX = savedSearchIndex;
        formInput.focus();
        formInput.select();

        formInput.addEventListener("input", (event) => {
          validateName(event);
        });
      });

      // open modal to delete saved search
      deleteOption.addEventListener("click", () => {
        savedSearchId = deleteOption.dataset.searchId;
        const savedSearchName = deleteOption.dataset.savedSearchName;

        formTitle.innerHTML = `Are you sure you want to delete "${savedSearchName}"?`;
        formDeleteBtn.style.display = "block";
        formSaveBtn.style.display = "none";
        formHeader.innerHTML = "Delete Saved Search";
        formInput.style.display = "none";
        modalContainer.style.display = "block";
        dropdownContent.classList.toggle("show");
        SELECTED_SAVED_SEARCH_INDEX = savedSearchIndex;
      });

      document.body.addEventListener("click", (event) => {
        if (
          !(
            event.target.classList.contains("fp-content-rename") ||
            event.target.classList.contains("fp-content-delete") ||
            event.target.classList.contains("fp-manage-content-btn")
          ) &&
          dropdownContent.classList.contains("show")
        ) {
          dropdownContent.classList.toggle("show");
        }
      });
    });
  });

  function closeModal() {
    formError.textContent = "";
    modalContainer.style.display = "none";
    const existingError = document.querySelector("#fp-save-search-error");
    if (existingError) existingError.remove();
    formInput.style.border = "";
  }

  const formError =
    document.getElementById("fp-form-error") ||
    (() => {
      const el = document.createElement("div");
      el.id = "fp-form-error";
      el.style.color = "var(--color-red)";
      el.style.marginTop = "0.625rem";
      formContainer.appendChild(el);
      return el;
    })();

  async function updateSavedSearch(name) {
    formError.textContent = "";
    const body = {
      id: savedSearchId,
      name,
    };

    const token = await window.getSessionToken();
    if (!token) {
      return { status: "error", message: "User not authenticated" };
    }
    try {
      const res = await fetch(`${webAppDomain}/saved-search/${savedSearchId}`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Shopify-Shop-Domain": getShopDomain(shopDomain),
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error("Network response was not ok");
      invalidateAllSavedSearches();
      return await res.json();
    } catch (error) {
      formError.textContent = "We encountered an error while updating the saved search. Please try again.";
      throw error;
    }
  }

  async function deleteSavedSearch() {
    formError.textContent = "";
    const body = {
      id: savedSearchId,
    };

    const token = await window.getSessionToken();
    if (!token) {
      return { status: "error", message: "User not authenticated" };
    }
    try {
      const res = await fetch(`${webAppDomain}/saved-search/${savedSearchId}`, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Shopify-Shop-Domain": getShopDomain(shopDomain),
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error("Network response was not ok");
      invalidateAllSavedSearches();
      return await res.json();
    } catch (error) {
      formError.textContent = "We encountered an error while deleting the saved search. Please try again.";
      throw error;
    }
  }
};

document.addEventListener("algolia.instantSearch.onRender", function () {
  document.dispatchEvent(new Event("swym:update-social-count"));
});

const getShopDomain = (domain) => {
  if (domain === "ecom-www.fashionphile.dev") {
    return "fashionphile-dev.myshopify.com";
  }

  if (domain === "www.staging.fashionphile.com") {
    return "fashionphile-staging.myshopify.com";
  }

  if (domain === "shopify.fashionphile.com" || domain === "www.fashionphile.com") {
    return "9b6844-68.myshopify.com";
  }

  return domain;
};

const validateName = (event) => {
  const input = event.target;
  const submitButton = document.getElementById("fp-form-save");
  const maxLength = 140;
  const currentLength = input.value.length;

  if (currentLength >= maxLength) {
    displayErrorMessage(`Name cannot exceed ${maxLength} characters`, input, submitButton);
  } else if (currentLength === 0) {
    displayErrorMessage("Please enter a saved search name.", input, submitButton);
  } else {
    const errorMessage = document.getElementById("fp-save-search-error");
    if (errorMessage) {
      errorMessage.remove();
    }
    input.style.border = "";
    if (submitButton && submitButton.disabled) {
      submitButton.disabled = false;
      submitButton.classList.remove("disabled");
    }
  }
};

const displayErrorMessage = (errorMessageText, input, submitButton) => {
  const errorMessage = document.createElement("div");
  errorMessage.id = "fp-save-search-error";
  errorMessage.className = "body-sm";
  errorMessage.style.color = "var(--color-red)";
  errorMessage.style.paddingTop = "0.25rem";
  errorMessage.style.display = "flex";
  errorMessage.style.gap = "0.5rem";
  errorMessage.role = "alert";

  const errorMessageIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path d="M15.8199 13.3872C16.3326 14.2758 15.6891 15.3865 14.665 15.3865H1.33484C0.308813 15.3865 -0.331797 14.274 0.179925 13.3872L6.84509 1.83265C7.35806 0.94365 8.64287 0.945261 9.15492 1.83265L15.8199 13.3872ZM8 10.9983C7.29431 10.9983 6.72223 11.5703 6.72223 12.2759C6.72223 12.9815 7.29431 13.5535 8 13.5535C8.7057 13.5535 9.27778 12.9815 9.27778 12.2759C9.27778 11.5703 8.7057 10.9983 8 10.9983ZM6.78687 6.40607L6.99292 10.1833C7.00256 10.36 7.14873 10.4984 7.32575 10.4984H8.67425C8.85128 10.4984 8.99745 10.36 9.00709 10.1833L9.21314 6.40607C9.22356 6.21516 9.07153 6.05463 8.88031 6.05463H7.11967C6.92845 6.05463 6.77645 6.21516 6.78687 6.40607Z" fill="#eb0008"/>
  </svg>
  `;

  const existingError = document.querySelector("#fp-save-search-error");
  if (existingError) {
    existingError.remove();
  }

  errorMessage.textContent = errorMessageText;

  input.parentNode.insertBefore(errorMessage, input.nextSibling);
  errorMessage.insertAdjacentHTML("afterbegin", errorMessageIcon);
  input.style.border = "0.0625rem solid var(--color-red)";

  if (submitButton) {
    submitButton.disabled = true;
    submitButton.classList.add("disabled");
  }
};

const transitionSaveButtonState = (state) => {
  const saveButton = document.getElementById("fp-form-save");

  if (!saveButton) return;

  if (state === "pending") {
    saveButton.disabled = true;
    saveButton.innerHTML = "Saving...";
    saveButton.classList.add("disabled");
  }

  if (state === "idle") {
    saveButton.disabled = false;
    saveButton.innerHTML = "Save";
    saveButton.classList.remove("disabled");
  }
};

document.addEventListener("click", (event) => {
  const btn = event.target.closest(".fp-manage-content-btn");
  const dropdowns = document.querySelectorAll(".fp-dropdown-content");
  if (btn) {
    const index = btn.dataset.savedSearchIndex;
    const screen = btn.dataset.screenSize;
    const dropdown = document.querySelector(
      `.fp-dropdown-content[data-saved-search-index="${index}"][data-screen-size="${screen}"]`,
    );
    if (!dropdown) return;
    const isCurrentlyOpen = dropdown.style.display === "block";
    dropdowns.forEach((el) => {
      el.style.display = "none";
    });
    dropdown.style.display = isCurrentlyOpen ? "none" : "block";
    return;
  }
  dropdowns.forEach((el) => {
    el.style.display = "none";
  });
});
